import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthPageComponent } from './containers';
import { AuthPageRootComponent } from './containers/auth-page-root/auth-page-root.component';

const routes: Routes = [
  // {
  //   path: '',
  //   component: AuthPageRootComponent,
  //   children: [
      
  //   ]
  // }
  {
    path: '',
    component: AuthPageComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})

export class AuthRoutingModule {
}
